export default __webpack_public_path__ + "static/media/failed.5ce1301d.svg";